<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div v-for="(item,index) in singleTrainingArr" :key="index">
          <div class="container cont-bdr mb-5">
            <!-- row starts -->
            <div class="row">
              <!-- ----------------------------------- -->
              <!-- col-md starts -->
              <div class="col-md-12 col-bdr-bottom">
                <p class="mt-2 mb-2">
                  <span>
                    <strong>Report Title</strong>
                  </span>
                  <span class="float-right">
                    <strong>Event Code :</strong> T327
                  </span>
                </p>
              </div>
              <!-- col-md ends -->
              <!-- ----------------------------------- -->
              <!-- col-md starts -->
              <div class="col-md-4 col-bdr-bottom">
                <img :src="basepath+'/unodc_logo.png'" class="mt-2 mb-2" alt="UNODC" width="200" />
              </div>
              <!-- col-md ends -->
              <!-- ----------------------------------- -->
              <!-- col-md starts -->
              <div class="col-md-4 col-bdr-bottom">
                <p class="mt-2 mb-2">
                  <span>
                    <strong>Plot # 5-11, Diplomatic Enclave, G-5, P.O.BOX 1051, Islamabad 44000, Pakistan</strong>
                  </span>
                </p>
              </div>
              <!-- col-md ends -->
              <!-- ----------------------------------- -->
              <!-- col-md starts -->
              <div class="col-md-4 col-bdr-bottom">
                <p class="mt-2 mb-2">
                  <span>
                    <strong>Country Office Pakistan</strong>
                  </span>
                </p>
              </div>
              <!-- col-md ends -->
              <!-- ----------------------------------- -->
              <!-- col-md starts -->
              <div class="col-md-12 col-bdr-bottom">
                <p class="mt-2 mb-2">
                  <span>
                    <strong>Name of Event :</strong> Training on "Administrative Management, Managing Audit and Accounts"
                  </span>
                </p>
              </div>
              <!-- col-md ends -->
              <!-- ----------------------------------- -->
            </div>
            <!-- row ends -->
          </div>
          <div class="container-fluid">
            <div class="col-sm-12">
              <div class="heading mt-3">
                <h3 class="text-secondary">
                  Training Program Report
                  <span
                    class="btn btn-primary float-right btn-sm print-btn"
                    @click="printReport"
                  >
                    <i class="material-icons">print</i> Print
                  </span>
                </h3>
              </div>

              <div class="form-group form-row text-dark">
                <h6 class="sub-frm-title">Training Information</h6>
                <div class="row col-sm-12">
                  <label class="col-sm-2 font-weight-bold">Title:</label>
                  <div class="col-sm-10">
                    <router-link 
                    :to="{ path: '/dashboard/programOfficer/GraphsOfficer', query: { trainingId: item.training_id }}"
                   >{{item.title}}</router-link>
                  </div>
                </div>
                <div class="row col-sm-12" v-if="item.startdate">
                  <label
                    class="col-sm-2 font-weight-bold"
                    style="padding:0px 0px 0px 15px"
                  >Start Date:</label>
                  <p
                    v-if="item.startdate != ''"
                    class="col-sm-2"
                    style="padding:0px 0px 0px 15px"
                  >{{item.startdate}}</p>

                  <label v-if="item.enddate != ''" class="col-sm-2 font-weight-bold p-0">End Date:</label>
                  <p v-if="item.enddate != ''" class="col-sm-2 p-0">{{item.enddate}}</p>
                </div>
                <div class="row col-sm-12">
                  <label class="col-sm-2 font-weight-bold" style="padding:0px 0px 0px 15px">Country:</label>
                  <p class="col-sm-2" style="padding:0px 0px 0px 15px">{{item.country}}</p>

                  <label class="col-sm-2 font-weight-bold p-0">City:</label>
                  <p class="col-sm-2 p-0">{{item.city}}</p>
                  <label class="col-sm-2 font-weight-bold p-0">Province:</label>
                  <p class="col-sm-2 p-0">{{item.province}}</p>
                </div>
                <div class="row col-sm-12">
                  <label
                    class="col-sm-2 font-weight-bold"
                    style="padding:0px 0px 0px 15px"
                  >No. of Trainees (Participants)</label>
                  <p class="col-sm-2" style="padding:0px 0px 0px 15px">
                    <router-link
                     :to="{ path: '/dashboard/programOfficer/trainingReportOfficer', query: { trainingId: item.training_id }}"
                      
                      class="linked"
                    >{{traineeCount}}</router-link>
                  </p>

                  <label class="col-sm-2 font-weight-bold p-0">Male:</label>
                  <p class="col-sm-2 p-0">{{maleCounter}}</p>
                  <label class="col-sm-2 font-weight-bold p-0">Female:</label>
                  <p class="col-sm-2 p-0">{{femaleCounter}}</p>
                </div>
                <div class="row col-sm-12">
                  <label
                    class="col-sm-2 font-weight-bold"
                    style="padding:0px 0px 0px 15px"
                  >Overall Satisfaction:</label>
                  <p class="col-sm-2" style="padding:0px 0px 0px 15px">87%</p>
                  <label class="col-sm-2 font-weight-bold p-0">Knowledge Gain:</label>
                  <p class="col-sm-2 p-0">98%</p>

                  <label class="col-sm-2 font-weight-bold p-0">Department / Organization:</label>
                  <p class="col-sm-2 p-0">Police Department Swat</p>
                </div>
                <div class="row col-sm-12">
                  <label class="col-sm-2 font-weight-bold" style="padding:0px 0px 0px 15px">Advisor:</label>
                  <p class="col-sm-2" style="padding:0px 0px 0px 15px">{{item.advisor}}</p>
                  <label class="col-sm-2 font-weight-bold p-0">Program Officer:</label>
                  <p class="col-sm-2 p-0">
                    <span v-for="(officer,index) in item.programOfficer" :key="index">
                      {{officer.name}}
                      <span v-if="index+1 < item.programOfficer.length">,</span>
                    </span>
                  </p>

                  <label class="col-sm-2 font-weight-bold p-0">Subprogram:</label>
                  <p class="col-sm-2 p-0">{{item.subprogram}}</p>
                </div>

                <div class="row col-sm-12">
                  <label class="col-sm-2 font-weight-bold" style="padding:0px 0px 0px 15px">Project:</label>
                  <p class="col-sm-2" style="padding:0px 0px 0px 15px">{{item.projectName}}</p>

                  <label class="col-sm-2 font-weight-bold p-0">Training Type:</label>
                  <p class="col-sm-2 p-0">{{item.trainingType}}</p>

                  <label class="col-sm-2 font-weight-bold p-0">Program ID:</label>
                  <p class="col-sm-2 p-0">{{item.programId}}</p>
                </div>
              </div>
              
              <div class="form-group form-row text-dark" v-if="AgencyLogos">
                <h6 class="sub-frm-title">Funding Agency</h6>
                <div class="row col-sm-12">
                  <div class="col-sm-6" v-for="(agency, keys) in AgencyLogos" :key="keys">

                  
                  <label class=" font-weight-bold">{{agency.title}}:</label>
                  <div>
                    <img :src="BASEPATHDYNAMIC+'/'+agency.image" alt width="20%" />
                  </div>
                </div>
                </div>
              </div>

              <div class="form-group form-row text-dark">
                <h6 class="sub-frm-title">Feedback</h6>
                <div class="row col-sm-12"></div>
                <div class="row col-sm-12">
                  <label
                    class="col-sm-4 font-weight-bold"
                    style="padding:0px 0px 0px 15px"
                  >Level of satisfaction regarding methodology:</label>
                  <p class="col-sm-2 p-0">Good</p>

                  <label class="col-sm-3 font-weight-bold p-0">language:</label>
                  <p class="col-sm-2" style="padding:0px 0px 0px 15px">Satisfactory</p>
                </div>

                <div class="row col-sm-12">
                  <label
                    class="col-sm-4 font-weight-bold"
                    style="padding:0px 0px 0px 15px"
                  >Relevance to training:</label>
                  <p class="col-sm-2 p-0">Training</p>

                  <label class="col-sm-3 font-weight-bold p-0">Percentage Knowledge gap:</label>
                  <p class="col-sm-2" style="padding:0px 0px 0px 15px">Highest</p>
                </div>

                <div class="row col-sm-12">
                  <label
                    class="col-sm-4 font-weight-bold"
                    style="padding:0px 0px 0px 15px"
                  >Duration:</label>
                  <p class="col-sm-2 p-0">Good</p>
                  <label class="col-sm-3 font-weight-bold p-0">Future use of training knowledge:</label>
                  <p class="col-sm-2" style="padding:0px 0px 0px 15px">Yes</p>
                </div>

                <div class="row col-sm-12">
                  <label
                    class="col-sm-4 font-weight-bold"
                    style="padding:0px 0px 0px 15px"
                  >Use of practical exercises:</label>
                  <p class="col-sm-2 p-0">Good</p>

                  <label class="col-sm-3 font-weight-bold p-0">Frequency of skills:</label>
                  <p class="col-sm-2" style="padding:0px 0px 0px 15px">Yes</p>
                </div>
                <div class="row col-sm-12"></div>
              </div>
              <div class="form-group form-row text-dark">
                <h6 class="sub-frm-title">Trainers</h6>

                <div class="row col-sm-12 p-2">
                  <div class="table-responsive">
                    <table  v-if="alltrainers != ''" class="table table-borderless">
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Contact No.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(trainer,index) in alltrainers" :key="index">
                          <td>{{index+1}}</td>
                          <td>{{trainer.trainer.name}}</td>
                          <td>{{trainer.trainer.email}}</td>
                          <td>{{trainer.trainer.mobile}}</td>
                        </tr>
                      </tbody>
                    </table>

                    <p v-else class="ml-3">No data found</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

export default {
  data: () => ({
    basepath: localStorage.getItem("BASE_PATH"),
    isSidebar: false,
    singleTrainingArr: [],
    datesArr: [],
    alltrainers:[],
    BASEPATHDYNAMIC: "",
    AgencyLogos :[],
    trainerId: "",
    traineeCount:0,
    maleCounter : 0,
    femaleCounter:0
  }),
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length;
    this.trainerId = this.$route.query.trainingId;
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/single/training/get/allTraineeCount/" +
          this.trainerId
      ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        if(response.data){
          if(response.data.count){
            this.traineeCount = response.data.count;
          }
          else{
            this.traineeCount = 0;
          }
          if(response.data.maleCounter){
            this.maleCounter = response.data.maleCounter;
          }
          else{
            this.maleCounter = 0;
          }
          if(response.data.femaleCounter){
            this.femaleCounter = response.data.femaleCounter;
          }
          else{
            this.femaleCounter = 0;
          }
        }
        
      })
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/single/training/trainer/get/" +
          this.trainerId
      ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.alltrainers = response.data;
      })
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/single/training/get/" +
          this.trainerId
      ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if(response.data != null && response.data.training != undefined && response.data.training.doner_id != undefined){
          this.fundingAgency = response.data.training.doner_id;
          axios
            .post(localStorage.getItem("BASE_PATH") + "/fundingAgency/get", {
              training_id: this.trainerId,
              fundingAgency : this.fundingAgency
            },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
                this.AgencyLogos = response.data;
            })
        }
        this.singleTrainingArr.push({
          id: response.data.id,
          title: response.data.training.title,
          training_id: response.data.training.id,
          startdate: response.data.training.startdate,
          enddate: response.data.training.enddate,
          country: response.data.training.district.province.country.title,
          city: response.data.training.district.title,
          province: response.data.training.district.province.title,
          noOfTrainee: response.data.totaltrainee,
          noOfTraineeMale: response.data.traineesMale,
          noOfTraineeFemale: response.data.traineesFemale,
          advisor: response.data.advisor_name.name,
          programOfficer: response.data.programOfficer,
          subprogram: response.data.training.subprogram.title,
          projectName: response.data.projectName.title,
          trainingType: response.data.trainingType.title,
          programId: response.data.training.subprogram.code,
          noOfTrainers: response.data.noOfTrainers
        });
      });
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    printReport: function() {
      window.print();
    }
  }
};
</script>
<style>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
li {
  list-style-type: none !important;
}

.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}
.cont-bdr {
  display: none;
}
@media print {
  .print-btn {
    display: none;
  }
  .cont-bdr {
    display: block;
  }
  .heading {
    display: none;
  }
}
.cont-bdr {
  border-top: 1px solid #ebe9e9;
  border-right: 1px solid #ebe9e9;
}
.col-bdr-bottom {
  border-bottom: 0.5px solid #ebe9e9;
  border-left: 0.5px solid #ebe9e9;
}
</style>


